/**
 * Cultural region pillars for the Real Names hub.
 *
 * The pillar list is precomputed by scripts/data/buildRealNamePillars.cjs and
 * committed as src/data/nav/realNamePillars.json. Do not derive it from
 * src/data/categories/real-names.json here: this module is imported by the
 * client component CategoryHubClient, and doing so pulled the entire 5.3 MB
 * dataset into the browser bundle on every page.
 *
 * Region definitions live in scripts/data/realNameRegions.cjs. After editing
 * them (or the real-names dataset), regenerate with:
 *   node scripts/data/buildRealNamePillars.cjs
 */

import realNamePillars from "@/data/nav/realNamePillars.json";

export interface CulturalSubcategory {
  name: string;
  slug: string;
  description?: string;
  count?: number;
}

export interface CulturalRegionPillar {
  id: string;
  name: string;
  shortName: string;
  icon: string;
  tagline: string;
  description: string;
  image: string;
  subcategories: CulturalSubcategory[];
}

export const REAL_NAME_PILLARS = realNamePillars as CulturalRegionPillar[];
